//import { debug } from 'console';
import { Action, Reducer } from 'redux'
import { AppThunkAction } from '.';
import * as myCfg from '../AppConfig';
import { LoadArInfo } from './BillTo';
import { BillToModel } from '../models/BillToModel'
import { SetValuesAction } from '../store/Session';
import { APIContainer, sawinFunc } from './sawinLib';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface UserState {
    Phone: string;
    Password: string;
    IsLoggedIn: boolean;
    Name: string;
    CompanyName: string;
    LogInError: string;
    IsPhoneValid: boolean;
    triggerFrom: string;
    isProcessing: boolean;
    RequestForAccess: boolean;
}
  
export interface LogInResult {
    success: boolean;
   // companyName: string;
   // userName: string;
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

export interface LogInStartProcessing { type: 'LOG_IN_PROCESSING' }
export interface LogInFinishProcessing { type: 'LOG_IN_FINISH_PROCESSING', errors: string }
export interface PhoneValidatedAction { type: 'PHONE_VALIDATED', newState: UserState }
export interface PhoneNotValidAction { type: 'PHONE_NOT_VALID', newState: UserState }
export interface AccessCodeNotValidAction { type: 'ACCESS_CODE_NOT_VALID', newState: UserState }
export interface LogInAction { type: 'LOG_IN', newState: UserState }
export interface LogOffAction { type: 'LOG_OFF' } 
export interface LogInFromStorage { type: 'LOG_IN_FROM_STORAGE', newState: UserState }
export interface LogInRequestForAccess { type: 'LOG_IN_REQUEST_ACCESS', accessState: boolean }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = LogInAction | LogOffAction | PhoneValidatedAction |
    PhoneNotValidAction | AccessCodeNotValidAction | LogInFromStorage | SetValuesAction | LoadArInfo |
    LogInStartProcessing | LogInFinishProcessing | LogInRequestForAccess;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    validatePhone: (pState: UserState): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState();       
        try {

            dispatch({
                type: 'LOG_IN_PROCESSING'
            });

            //Validate Phone or email
            if (isNaN(Number(pState.Phone))) {
                //Validate Email
                if (pState.Phone.indexOf("@") < 1) {
                    dispatch({
                        type: 'LOG_IN_FINISH_PROCESSING', errors: "Email format is not correct"
                    });
                    return;
                }
            } else {
                if (pState.Phone.length != 10) {
                    dispatch({
                        type: 'LOG_IN_FINISH_PROCESSING', errors: "Phone number must be 10 digits"
                    });
                    return;
                }                
            }


            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/User/validatePhone',
                {
                    method: 'POST',
                    body: JSON.stringify({
                        "Phone": pState.Phone,
                        "AccessCode": pState.Password
                    }),
                    headers: { 'Content-Type': 'application/json' }
                })              
                .then(response => response.json() as Promise<APIContainer>)                    
                .then(container => {
                    dispatch({
                        type: 'LOG_IN_FINISH_PROCESSING',
                        errors: ""
                    });

                    if (container.success) {

                        const data: LogInResult = container.data;

                        if (data.success) {
                            dispatch({ type: 'PHONE_VALIDATED', newState: pState });
                        } else {
                            dispatch({ type: 'PHONE_NOT_VALID', newState: pState });
                        }
                    } else {
                        dispatch({
                            type: 'LOG_IN_FINISH_PROCESSING', errors: "Server error:" + container.errorInfo.message //err.message
                        });
                    }
                })
                .catch(function (err: Error) {
                   dispatch({
                       type: 'LOG_IN_FINISH_PROCESSING', errors: "Server error:" + err.message //err.message
                 });
               }); 
                
        } catch (err) {
            dispatch({
                type: 'LOG_IN_FINISH_PROCESSING', errors:err});
        }

    },
    validateAuthCode: (pState: UserState): AppThunkAction<KnownAction> => (dispatch, getState) => {
     
            dispatch({
                type: 'LOG_IN_PROCESSING'
            });
            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/User/validateAuthCode',
                {
                    method: 'POST',
                    body: JSON.stringify({
                        "Phone": pState.Phone,
                        "AccessCode": pState.Password
                    }),
                    headers: { 'Content-Type': 'application/json' }
                })               
                .then(response => response.json() as Promise<APIContainer>)
                .then(container => {


                    if (container.success) {                        
                        dispatch({
                            type: 'LOG_IN_FINISH_PROCESSING', errors: ''
                        });
                     
                        var data: BillToModel[];
                        data = container.data;

                        if (data.length > 0) {
                            pState.IsLoggedIn = true;
                            pState.LogInError = "";
                            pState.IsPhoneValid = true;
                            localStorage.setItem("UserStored", JSON.stringify({ "Phone": pState.Phone, "Password": pState.Password }));
                            dispatch({ type: 'BILLTO_LOAD', newState: { items: data } });
                            dispatch({
                                type: 'SESSION_SET_VALUES', newState: {
                                    SelectedAR: data[0],
                                    SelectedSM: data[0].serviceMasters[0],
                                    TransactionFeeEnabled: false,
                                    TransactionFeePerc: 0,
                                    TransactionFeeLabel: '',
                                    CheckSalesAmtMin: false,
                                    SalesAmountLowerCeiling: 0
                                }
                            });
                            dispatch({ type: 'LOG_IN', newState: pState });
                        } else {
                            //localStorage.removeItem("UserStored");
                            dispatch({ type: 'ACCESS_CODE_NOT_VALID', newState: pState });
                        }
                    } else {                        
                        dispatch({
                            type: 'LOG_IN_FINISH_PROCESSING', errors: container.errorInfo.message
                        });
                    }
                })
                .catch(function (err: Error) {
                    dispatch({
                        type: 'LOG_IN_FINISH_PROCESSING', errors: "Server error:" + err.message //err.message
                    });                    
                });                        
       

    },
    logOff: () => ({ type: 'LOG_OFF' } as LogOffAction),
    requestAccess: (pEnable: boolean) => ({ type: 'LOG_IN_REQUEST_ACCESS', accessState: pEnable} as LogInRequestForAccess )
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const initialState: UserState = { Phone: "", Password: "", IsLoggedIn: false, CompanyName: "", Name: "", LogInError: "", IsPhoneValid: false, triggerFrom:"", isProcessing: false, RequestForAccess:false };

export const reducer: Reducer<UserState> = (state: UserState | undefined, incomingAction: Action): UserState => {
 
    if (state === undefined) {
        return initialState;
    }
    const action = incomingAction as KnownAction;
   // debugger;
    switch (action.type) {
        case 'LOG_IN':
            const logInAction = incomingAction as LogInAction;
            return logInAction.newState;
        case 'LOG_IN_REQUEST_ACCESS':
            const requestAction = action as LogInRequestForAccess;
            return {

                ...state, ...{ RequestForAccess: requestAction.accessState }
            };
        case 'LOG_OFF':
            localStorage.removeItem("UserStored");
            return initialState;
        case 'PHONE_VALIDATED':
            const phoneValidAction = incomingAction as PhoneValidatedAction;
            phoneValidAction.newState.IsPhoneValid = true;
            phoneValidAction.newState.LogInError = "";
            return phoneValidAction.newState;        
        case 'PHONE_NOT_VALID':
            const phoneNotValidAction = incomingAction as PhoneValidatedAction;
            if (phoneNotValidAction.newState.triggerFrom == "LOCAL_STORAGE") {
                phoneNotValidAction.newState.LogInError = ""
                phoneNotValidAction.newState.IsPhoneValid = false;
            } else {
                phoneNotValidAction.newState.LogInError = "Phone or email not found";
            }            
            return phoneNotValidAction.newState;
        case 'ACCESS_CODE_NOT_VALID':
            const accessCodeNotValidAction = incomingAction as AccessCodeNotValidAction;
            if (accessCodeNotValidAction.newState.triggerFrom !== "LOCALSTORAGE") {
                accessCodeNotValidAction.newState.LogInError = "Access Code not valid";
            } else {
                accessCodeNotValidAction.newState.LogInError = "";
            }
            return accessCodeNotValidAction.newState; 
        case 'LOG_IN_PROCESSING':
            return { ...state, ...{ isProcessing: true } };
        case 'LOG_IN_FINISH_PROCESSING':            
            return { ...state, ...{ isProcessing: false, LogInError: (incomingAction as LogInFinishProcessing).errors } };
        default:
            return state;
    }
}; 
